import { useSearch } from '@/react/portainer/gitops/queries/useSearch';
import {
  PORTAINER_EDGE_GROUP_VARIABLE,
  PORTAINER_EDGE_ID_VARIABLE,
} from '@/react/edge/edge-stacks/types';

import { AutocompleteSelect } from '@@/form-components/AutocompleteSelect';
import { FormError } from '@@/form-components/FormError';

import { GitFormModel } from '../types';

export type PathSelectorGitModel = Pick<
  GitFormModel,
  'RepositoryReferenceName' | 'SourceId'
>;

export function PathSelector({
  value,
  onChange,
  placeholder,
  model,
  dirOnly,
  readOnly,
  allowEmpty,
  inputId,
  hasError,
}: {
  value: string;
  onChange(value: string): void;
  placeholder: string;
  model: PathSelectorGitModel;
  dirOnly?: boolean;
  readOnly?: boolean;
  allowEmpty?: boolean;
  inputId: string;
  hasError?: boolean;
}) {
  const payload = {
    keyword: value,
    reference: model.RepositoryReferenceName,
    dirOnly,
    sourceId: model.SourceId,
  };

  // Check if the path contains dynamic variables (skip validation if it does)
  const hasDynamicVariables =
    value.includes(PORTAINER_EDGE_GROUP_VARIABLE) ||
    value.includes(PORTAINER_EDGE_ID_VARIABLE);

  const enabled = !!(model.SourceId && value && !hasDynamicVariables);

  const { data: searchResults } = useSearch(payload, enabled);
  const isValueValid =
    (allowEmpty && value === '') ||
    hasDynamicVariables ||
    searchResults?.includes(value);

  return (
    <>
      <AutocompleteSelect
        searchResults={searchResults?.map((result) => ({
          value: result,
          label: result,
        }))}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        inputId={inputId}
        data-cy="git-ops-path-selector"
      />
      {!hasError && !isValueValid && <FormError>Path not found</FormError>}
    </>
  );
}
